// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Backdrop */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 15, 30, 0.9);
  backdrop-filter: blur(5px);
  z-index: var(--z-modal-backdrop);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-lg);
}

/* Modal Card */
.modal-card {
  max-width: 500px;
  width: 100%;
  box-shadow: var(--shadow-xl);
  max-height: 90vh;
  overflow-y: auto;
}

/* Modal Header */
.modal-header {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  margin-bottom: var(--space-lg);
}

.modal-icon {
  font-size: 3rem;
  flex-shrink: 0;
  animation: pulse 2s ease-in-out infinite;
}

/* Icon colour per alert type (was an inline style) */
.modal-icon--info {
  color: var(--color-info);
}

.modal-icon--success {
  color: var(--color-success);
}

.modal-icon--error {
  color: var(--color-error);
}

.modal-icon--warning {
  color: var(--color-warning);
}

@media (prefers-reduced-motion: reduce) {
  .modal-icon {
    animation: none;
  }
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }
}

.modal-title {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-white);
  margin: 0;
}

/* Modal Message */
.modal-message {
  font-size: var(--font-size-lg);
  line-height: var(--line-height-relaxed);
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

/* Long unbroken strings (URLs) must not overflow the dialog */
.modal-message--wrap {
  white-space: pre-wrap;
  word-break: break-all;
}

.modal-input {
  width: 100%;
  padding: var(--space-sm) var(--space-md);
  margin-top: var(--space-md);
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: var(--radius-md);
  color: white;
  font-size: var(--font-size-base);
  outline: none;
}

.modal-input:focus {
  border-color: var(--color-primary);
}

/* Small screens: keep the dialog clear of notches and home indicators. */
@media (max-width: 600px) {
  .modal-backdrop {
    padding: calc(var(--space-md) + env(safe-area-inset-top)) calc(var(--space-md) + env(safe-area-inset-right)) calc(var(--space-md) + env(safe-area-inset-bottom)) calc(var(--space-md) + env(safe-area-inset-left));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal.css"],"names":[],"mappings":"AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,0BAA0B;EAC1B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,wCAAwC;AAC1C;;AAEA,qDAAqD;AACrD;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE;;IAEE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;EACzB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,SAAS;AACX;;AAEA,8DAA8D;AAC9D;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,2BAA2B;EAC3B,oCAAoC;EACpC,0CAA0C;EAC1C,+BAA+B;EAC/B,YAAY;EACZ,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA,yEAAyE;AACzE;EACE;IACE,kNAAkN;EACpN;AACF","sourcesContent":["@import '../styles/variables.css';\n\n/* Modal Backdrop */\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(15, 15, 30, 0.9);\n  backdrop-filter: blur(5px);\n  z-index: var(--z-modal-backdrop);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-lg);\n}\n\n/* Modal Card */\n.modal-card {\n  max-width: 500px;\n  width: 100%;\n  box-shadow: var(--shadow-xl);\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n/* Modal Header */\n.modal-header {\n  display: flex;\n  align-items: center;\n  gap: var(--space-md);\n  margin-bottom: var(--space-lg);\n}\n\n.modal-icon {\n  font-size: 3rem;\n  flex-shrink: 0;\n  animation: pulse 2s ease-in-out infinite;\n}\n\n/* Icon colour per alert type (was an inline style) */\n.modal-icon--info {\n  color: var(--color-info);\n}\n\n.modal-icon--success {\n  color: var(--color-success);\n}\n\n.modal-icon--error {\n  color: var(--color-error);\n}\n\n.modal-icon--warning {\n  color: var(--color-warning);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .modal-icon {\n    animation: none;\n  }\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n.modal-title {\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-white);\n  margin: 0;\n}\n\n/* Modal Message */\n.modal-message {\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-relaxed);\n  color: rgba(255, 255, 255, 0.9);\n  margin: 0;\n}\n\n/* Long unbroken strings (URLs) must not overflow the dialog */\n.modal-message--wrap {\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n.modal-input {\n  width: 100%;\n  padding: var(--space-sm) var(--space-md);\n  margin-top: var(--space-md);\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: var(--radius-md);\n  color: white;\n  font-size: var(--font-size-base);\n  outline: none;\n}\n\n.modal-input:focus {\n  border-color: var(--color-primary);\n}\n\n/* Small screens: keep the dialog clear of notches and home indicators. */\n@media (max-width: 600px) {\n  .modal-backdrop {\n    padding: calc(var(--space-md) + env(safe-area-inset-top)) calc(var(--space-md) + env(safe-area-inset-right)) calc(var(--space-md) + env(safe-area-inset-bottom)) calc(var(--space-md) + env(safe-area-inset-left));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
